module.exports = __webpack_public_path__ + "static/img/third2_1_6.684d3d75.jpg";